<template>
    <el-dialog :visible.sync='visible' class="el_dialog custom_title_dialog" @close="closeDialog" width="760px"
        top="10vh">
        <div slot="title" class="flex_start_center custom_title_box">
            <div class="custom_title">{{ dialogData.bed_number }}床 {{ dialogData.name }}</div>
            <div>
                <el-date-picker size="small" v-model="reportDate" type="date" placeholder="选择日期"
                    :picker-options="pickerOptions" @change="dateChange" :clearable="false"></el-date-picker>
            </div>
        </div>
        <div v-loading="loading">
            <div class="custom_body">
                <div class="sleep_chart_box">
                    <div class="part_title">睡眠分布</div>
                    <div class="pointer_text_box">
                        <div>
                            <div v-if="showChartDataDetail">{{ sleepTypeText }}
                                {{ (Number(this.detailData.duration) / 60).toFixed(0) }}分钟</div>
                        </div>
                        <div>
                            <div v-if="showChartDataDetail">{{ this.detailData.start_time }}-{{ this.detailData.end_time
                            }}
                            </div>
                        </div>
                    </div>
                    <div class="chart_box" id="sleepChart"></div>
                    <div class="chart_footer flex_space_between">
                        <div>{{ $dateFtt.dateFtt('M/d', new Date((new Date()).setDate(this.reportDate.getDate() - 1)))
                            }}</div>
                        <div>{{ $dateFtt.dateFtt('M/d', this.reportDate) }}</div>
                    </div>
                    <div class="chart_legend">
                        <div>无数据</div>
                        <div>深度睡眠</div>
                        <div>中度睡眠</div>
                        <div>轻度睡眠</div>
                        <div>零星小睡或静息</div>
                    </div>
                </div>
                <div class="sleep_time_box flex_space_between">
                    <div class="time_left">
                        <div v-if="sleepNoData" class="time_text value_text">--</div>
                        <div class="time_text" v-else>
                            <span class="value_text">{{ Math.floor(sleepData.total_sleep_time / 60) }}</span>
                            <span>小时</span>
                            <span class="value_text">{{ sleepData.total_sleep_time % 60 }}</span>
                            <span>分钟</span>
                        </div>
                        <div>夜间总睡眠</div>
                    </div>
                    <div class="split_line"></div>
                    <div class="time_right flex_space_between">
                        <div>
                            <div>轻度睡眠：<span>{{ !sleepData.light_sleep_time ? '--' :
                                sleepData.light_sleep_time.toFixed(1)
                                + 'H'
                                    }}</span></div>
                            <div>中度睡眠：<span>{{ !sleepData.mid_sleep_time ? '--' : sleepData.mid_sleep_time.toFixed(1) +
                                'H' }}</span>
                            </div>
                            <div>深度睡眠：<span>{{ !sleepData.deep_sleep_time ? '--' : sleepData.deep_sleep_time.toFixed(1)
                                +
                                'H' }}</span>
                            </div>
                        </div>
                        <div>
                            <div>有效睡眠：<span>{{ !sleepData.real_sleep_time ? '--' : sleepData.real_sleep_time.toFixed(1)
                                + 'H' }}</span>
                            </div>
                            <div>最大深睡：<span>{{ !sleepData.max_deep_sleep ? '--' : sleepData.max_deep_sleep.toFixed(1) +
                                'H' }}</span>
                            </div>
                            <div>小睡/静息：<span>{{ !sleepData.day_sleep_time ? '--' : sleepData.day_sleep_time.toFixed(1) +
                                'H' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sleep_quality_box">
                    <div class="flex_space_between border_bottom">
                        <div class="part_title">睡眠质量评估</div>
                        <div class="part_tips">趋势标识为今日数据与昨日数据对比</div>
                    </div>
                    <div class="flex_space_between quality_content">
                        <div class="quality_item_left">
                            <div class="flex_space_between">
                                <div class="quality_text">深度睡眠比例</div>
                                <div class="quality_value">{{ sleepNoData ? '--' : sleepData.deep_sleep_info }}</div>
                                <div class="quality_icon" v-if="!sleepNoData">
                                    <img src="@/assets/icon/icon_up.png" alt=""
                                        v-if="sleepData.compare_flag.compare_deep_sleep.flag == 1">
                                    <img src="@/assets/icon/icon_line.png" alt=""
                                        v-if="sleepData.compare_flag.compare_deep_sleep.flag == 0">
                                    <img src="@/assets/icon/icon_down.png" alt=""
                                        v-if="sleepData.compare_flag.compare_deep_sleep.flag == -1">
                                </div>
                            </div>
                            <div class="flex_space_between">
                                <div class="quality_text">中度睡眠比例</div>
                                <div class="quality_value">{{ sleepNoData ? '--' : sleepData.mid_sleep_info }}</div>
                                <div class="quality_icon" v-if="!sleepNoData">
                                    <img src="@/assets/icon/icon_up.png" alt=""
                                        v-if="sleepData.compare_flag.compare_mid_sleep.flag == 1">
                                    <img src="@/assets/icon/icon_line.png" alt=""
                                        v-if="sleepData.compare_flag.compare_mid_sleep.flag == 0">
                                    <img src="@/assets/icon/icon_down.png" alt=""
                                        v-if="sleepData.compare_flag.compare_mid_sleep.flag == -1">
                                </div>
                            </div>
                            <div class="flex_space_between">
                                <div class="quality_text">轻度睡眠比例</div>
                                <div class="quality_value">{{ sleepNoData ? '--' : sleepData.light_sleep_info }}</div>
                                <div class="quality_icon" v-if="!sleepNoData">
                                    <img src="@/assets/icon/icon_up.png" alt=""
                                        v-if="sleepData.compare_flag.compare_light_sleep.flag == 1">
                                    <img src="@/assets/icon/icon_line.png" alt=""
                                        v-if="sleepData.compare_flag.compare_light_sleep.flag == 0">
                                    <img src="@/assets/icon/icon_down.png" alt=""
                                        v-if="sleepData.compare_flag.compare_light_sleep.flag == -1">
                                </div>
                            </div>
                        </div>
                        <div class="quality_item_right">
                            <div class="flex_space_between">
                                <div class="quality_text">睡眠心率健康指数</div>
                                <div class="quality_value">{{ sleepNoData ? '--' : sleepData.sleep_hr_health_score + '分'
                                    }}
                                </div>
                                <div class="quality_icon" v-if="!sleepNoData">
                                    <img src="@/assets/icon/icon_up.png" alt=""
                                        v-if="sleepData.compare_flag.compare_hr_health.flag == 1">
                                    <img src="@/assets/icon/icon_line.png" alt=""
                                        v-if="sleepData.compare_flag.compare_hr_health.flag == 0">
                                    <img src="@/assets/icon/icon_down.png" alt=""
                                        v-if="sleepData.compare_flag.compare_hr_health.flag == -1">
                                </div>
                            </div>
                            <div class="flex_space_between">
                                <div class="quality_text">睡眠血氧健康指数</div>
                                <div class="quality_value">{{ sleepNoData ? '--' :
                                    sleepData.sleep_spo2_health_score + '分' }}</div>
                                <div class="quality_icon" v-if="!sleepNoData">
                                    <img src="@/assets/icon/icon_up.png" alt=""
                                        v-if="sleepData.compare_flag.compare_spo2_health.flag == 1">
                                    <img src="@/assets/icon/icon_line.png" alt=""
                                        v-if="sleepData.compare_flag.compare_spo2_health.flag == 0">
                                    <img src="@/assets/icon/icon_down.png" alt=""
                                        v-if="sleepData.compare_flag.compare_spo2_health.flag == -1">
                                </div>
                            </div>
                            <div class="flex_space_between">
                                <div class="quality_text">睡眠呼吸暂停风险</div>
                                <div class="quality_value">{{ sleepNoData ? '--' : sleepData.risk_of_snoring }}</div>
                                <div class="quality_icon" v-if="!sleepNoData">
                                    <img src="@/assets/icon/icon_up.png" alt=""
                                        v-if="sleepData.compare_flag.compare_osahs.flag == 1">
                                    <img src="@/assets/icon/icon_line.png" alt=""
                                        v-if="sleepData.compare_flag.compare_osahs.flag == 0">
                                    <img src="@/assets/icon/icon_down.png" alt=""
                                        v-if="sleepData.compare_flag.compare_osahs.flag == -1">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </el-dialog>
</template>
<script>
const ReportUrl = process.env.REPORT_API;
import axios from "axios";
import { sleepOption } from "./options";
import { watch } from "vue";

export default {
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        dialogData: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    watch: {
        dialogVisible(val) {
            this.visible = val;
            this.sleepNoData = true;
            this.sleepData = {};
            if (this.visible == true) {
                this.reportDate = new Date();
                this.getBindTime()
                this.fetchData();
            }
        },
        pointerIndex(val) {
            if (val == 144 || this.sleepNoData) {
                return
            }
            let sleep_val = this.sleepData.sleep_text[val]
            if (sleep_val == 10) {
                this.getDetailData(val, 'deep_sleep_interval_segment')
            } else if (sleep_val == 9) {
                this.getDetailData(val, 'mid_sleep_interval_segment')
            } else if (sleep_val == 1) {
                this.getDetailData(val, 'light_sleep_interval_segment')
            } else if (sleep_val == 3) {
                this.getDetailData(val, 'day_sleep_interval_segment')
            }
        },
    },
    computed: {
        showChartDataDetail() {
            return this.pointerIndex != 144 && this.sleepData.sleep_text && (this.sleepData.sleep_text[this.pointerIndex] == 10 || this.sleepData.sleep_text[this.pointerIndex] == 9 || this.sleepData.sleep_text[this.pointerIndex] == 1 || this.sleepData.sleep_text[this.pointerIndex] == 3)
        },
        sleepTypeText() {
            let typeList = {
                10: '深度睡眠',
                9: '中度睡眠',
                1: '轻度睡眠',
                3: '零星小睡或静息'
            }
            return typeList[this.sleepData.sleep_text[this.pointerIndex]]
        }
    },
    data() {
        return {
            visible: false,
            reportDate: new Date(),
            pickerOptions: {
                disabledDate(date) {
                    return new Date() < date;
                },
            },
            sleepNoData: true,
            sleepData: {},
            loading: false,
            pointerIndex: -1,
            detailData: {}
        };
    },
    methods: {
        getDetailData(index, key) {
            console.log(index, key);

            this.detailData = {}
            let _this = this
            let object = this.sleepData[key]
            for (const key in object) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    const element = object[key];
                    if (index >= element.start_time_index && index <= element.end_time_index) {
                        _this.detailData = element
                    }
                }
            }
            console.log(this.detailData);

        },
        closeDialog() {
            this.$emit('closeDialog');
        },
        getBindTime() {
            let data = {
                patient_id: this.dialogData.patient_id,
                bed_number: this.dialogData.bed_number,
                room_number: 9999,
                zone_number: localStorage.getItem('zone_number'),
            }
            axios({
                url: process.env.BASE_API + 'api/hope/time',
                method: 'post',
                data,
            }).then((res) => {
                if (res.data.status == 200) {
                    this.pickerOptions.disabledDate = (date) => {
                        return new Date(this.$dateFtt.dateFtt("yyyy/MM/dd 00:00:00", new Date(res.data.result.start * 1000))) > date || new Date() < date;
                    }
                }
            });
        },
        fetchData() {
            this.loading = true;
            this.sleepData = {}
            let date = this.$dateFtt.dateFtt("yyyyMMdd", this.reportDate);
            let url = `${ReportUrl}hospital_show/api/report/sleep_report_v2?date=${date}&patient_id=${this.dialogData.patient_id}&md5=${this.md5Str(this.dialogData.patient_id)}`
            this.$http({
                url: "/api/sync/sync_data",
                method: "GET",
                params: { url },
                headers: {
                    Token: localStorage.getItem("token"),
                },
            }).then((response) => {
                const result = JSON.parse(response.result);
                this.loading = false;
                if (typeof (result.info) !== 'string') {
                    this.sleepNoData = false;
                    this.sleepData = result.info;
                    this.pointerIndex = 0
                } else {
                    this.sleepNoData = true;
                }
                this.initSleepChart()
            })
                .catch((error) => {
                    console.log(error);

                    this.loading = false;
                    this.sleepNoData = true;
                    this.initSleepChart()
                })

        },
        dateChange() {
            this.pointerIndex = -1
            this.fetchData()
        },
        initSleepChart() {
            let sleepChart = echarts.init(document.getElementById('sleepChart'));

            if (this.sleepNoData) {
                sleepChart.showLoading({
                    text: '当日暂无活动数据~',
                    showSpinner: false, // 隐藏旋转动画
                    textColor: '#636676',
                    maskColor: '#F5F7FB',
                    fontSize: 18,
                    fontFamily: 'Source Han Sans CN-Regular'
                });
            } else {
                sleepChart.hideLoading();


                let xdata = [];
                let startTime = new Date()
                startTime = new Date(this.$dateFtt.dateFtt('yyyy/MM/dd', new Date(startTime.setDate(this.reportDate.getDate() - 1))) + ' 21:00:00');
                let time = startTime.getTime();
                for (var i = 0; i <= this.sleepData.sleep_text.length; i++) {
                    xdata.push([time, 1]);
                    time += 600000;
                }
                let _this = this
                sleepOption.series[0].data = sleepOption.series[1].data = sleepOption.series[2].data = sleepOption.series[3].data = xdata;
                sleepOption.series[0].itemStyle.color = (params) => {
                    let index = params.dataIndex,
                        color = 'transparent';
                    if (_this.sleepData.sleep_text[index] == 10) {
                        color = '#6377F5';
                    } else {
                        color = 'transparent';
                    }
                    return color;
                }
                sleepOption.series[1].itemStyle.color = (params) => {
                    let index = params.dataIndex,
                        color = 'transparent';
                    if (_this.sleepData.sleep_text[index] == 9) {
                        color = '#9E4AE3';
                    } else {
                        color = 'transparent';
                    }
                    return color;
                }
                sleepOption.series[2].itemStyle.color = (params) => {
                    let index = params.dataIndex,
                        color = 'transparent';
                    if (_this.sleepData.sleep_text[index] == 1) {
                        color = '#ED95F7';
                    } else {
                        color = 'transparent';
                    }
                    return color;
                }
                sleepOption.series[3].itemStyle.color = (params) => {
                    let index = params.dataIndex,
                        color = 'transparent';
                    if (_this.sleepData.sleep_text[index] == 3) {
                        color = '#80BAFA';
                    } else {
                        color = 'transparent';
                    }
                    return color;
                }
                sleepOption.tooltip.formatter = (params) => {
                    let index = params.dataIndex
                    _this.pointerIndex = index
                    return '';
                }
                sleepChart.setOption(sleepOption);
            }
        },
    },
}
</script>
<style scoped>
@import url('../../../assets/style/commo.css');

.custom_title {
    color: #252b50;
    font-size: 24px;
    font-weight: bolder;
    margin-right: 20px;
}

.custom_title_box>>>.el-input__inner {
    border: unset !important;
    font-size: 18px !important;
}


.sleep_chart_box {
    padding: 24px;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    border-radius: 8px 8px 8px 8px;
    margin-bottom: 12px;
}

.part_title {
    font-weight: bold;
    font-family: 'Source Han Sans CN-Bold';
    font-size: 18px;
    color: #252B50;
    height: 27px;
    line-height: 27px;
}

.pointer_text_box {
    font-size: 16px;
    color: #636676;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    margin-bottom: 14px;
}

.pointer_text_box>div:nth-child(1) {
    margin-right: 10px;
    font-family: 'Source Han Sans CN-Bold';
    color: #636676;
}

.chart_box {
    width: 100%;
    height: 220px;
}

.chart_footer {
    color: #9296AF;
    font-size: 12px;
    padding: 4px 6px 0 45px;
}

.chart_legend {
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #636676;
    margin-top: 12px;
    height: 21px;
    line-height: 21px;
}

.chart_legend>div {
    margin-right: 24px;
    padding-left: 14px;
    position: relative;
}

.chart_legend>div::before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
}

.chart_legend>div:nth-child(1)::before {
    background: #FFFFFF;
    border: 1px solid #636676;
}

.chart_legend>div:nth-child(2)::before {
    background: #6377F5;
}

.chart_legend>div:nth-child(3)::before {
    background: #9E4AE3;
}

.chart_legend>div:nth-child(4)::before {
    background: #ED95F7;
}

.chart_legend>div:nth-child(5)::before {
    background: #80BAFA;
}

.chart_legend>div:nth-child(5) {
    margin-right: 0;
}

.sleep_time_box {
    height: 120px;
    padding: 0 70px;
    background: #F5F7FB;
    border-radius: 8px 8px 8px 8px;
    color: #636676;
    font-size: 16px;
    margin-bottom: 12px;
}

.time_left {
    text-align: center;
}

.time_text {
    color: #9296AF;
    height: 52px;
    line-height: 48px;
    width: 166px;
}

.value_text {
    color: #252B50;
    font-size: 48px;
    font-family: 'Source Han Sans CN-Bold';
}

.split_line {
    border: 1px solid #EEEEEE;
    height: 72px;
}

.time_right {
    width: 280px;
}

.time_right>div>div {
    margin-bottom: 4px;
}

.time_right>div>div:last-child {
    margin-bottom: 0;
}

.time_right>div>div>span {
    color: #252B50;
}

.sleep_quality_box {
    padding: 24px;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    border-radius: 8px 8px 8px 8px;
}

.part_tips {
    font-size: 14px;
    color: #929FAF;
}

.border_bottom {
    padding-bottom: 16px;
    border-bottom: 1px solid #EEEEEE;
}

.quality_content {
    padding: 16px 60px 0;
    font-size: 16px;
    color: #636676;
}

.quality_content img {
    width: 16px;
}

.quality_content>div>div {
    margin-bottom: 16px;
    height: 16px;
    line-height: 16px;
}

.quality_content>div>div:last-child {
    margin-bottom: 0;
}

.quality_item_left {
    width: 170px;
}

.quality_item_right {
    width: 216px;
}

.quality_item_right .quality_value {
    width: 48px;
    word-wrap: nowrap;
}

.quality_value {
    color: #252B50;
}
</style>


// WEBPACK FOOTER //
// src/view/managePages/components/sleepDialog.vue